import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import PageHeader from "../components/PageHeader";
import CompanyPecBanner from "../components/CompanyPecBanner";
import DataTable from "../components/DataTable";
import LoadingState from "../components/LoadingState";
import SenderStatusBadge from "../components/SenderStatusBadge";
import { Button } from "../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

export default function SendersPage() {
    const { companyId, canAnalyze } = useAuth();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [statusF, setStatusF] = useState("__any__");

    const load = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams();
            if (statusF !== "__any__") params.append("status_f", statusF);
            const { data } = await api.get(`/senders?${params}`);
            setItems(data?.items || []);
        } catch (e) { toast.error("Errore"); }
        finally { setLoading(false); }
    };
    useEffect(() => { load(); /* eslint-disable-next-line */ }, [companyId, statusF]);

    const changeStatus = async (sender, status) => {
        try {
            await api.patch(`/senders/${sender.id}/status`, { status });
            toast.success("Stato aggiornato");
            load();
        } catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
    };

    const columns = [
        { key: "display_name", header: "Nome", sortable: true, render: r => (
            <div><div className="text-sm font-medium">{r.display_name || "—"}</div><div className="text-xs text-[#64748B]">{r.address}</div></div>
        )},
        { key: "status", header: "Stato", render: r => <SenderStatusBadge status={r.status} /> },
        { key: "identity_confidence", header: "Confidence", sortable: true, render: r => `${r.identity_confidence ?? 0}/100` },
        { key: "message_count", header: "Messaggi", sortable: true },
        { key: "last_seen_at", header: "Ultimo msg", render: r => r.last_seen_at ? new Date(r.last_seen_at).toLocaleString("it-IT") : "—" },
        { key: "actions", header: "", render: r => canAnalyze() ? (
            <div className="flex gap-1 justify-end">
                <Button size="sm" variant="outline" data-testid={`confirm-sender-${r.id}`} onClick={() => changeStatus(r, "Confermato")}>Conferma</Button>
                <Button size="sm" variant="outline" className="text-[#DC2626]" data-testid={`block-sender-${r.id}`} onClick={() => changeStatus(r, "Bloccato")}>Blocca</Button>
            </div>
        ) : null, className: "text-right" },
    ];

    return (
        <div className="space-y-6">
            <PageHeader title="Mittenti" subtitle="Registro dei mittenti PEC con livello di fiducia calcolato." breadcrumbs={[{ label: "Mittenti" }]} />
            <CompanyPecBanner />
            <div className="bg-white border border-[#DCE3EE] rounded-xl p-4 flex gap-3">
                <div className="w-64">
                    <Select value={statusF} onValueChange={setStatusF}>
                        <SelectTrigger className="h-9" data-testid="senders-status-filter"><SelectValue placeholder="Stato" /></SelectTrigger>
                        <SelectContent className="bg-white">
                            <SelectItem value="__any__">Tutti gli stati</SelectItem>
                            {["Nuovo","Conosciuto","Confermato","Sospetto","Incoerente","Bloccato"].map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}
                        </SelectContent>
                    </Select>
                </div>
            </div>
            {loading ? <LoadingState /> : <DataTable testId="senders-table" columns={columns} data={items} pageSize={15} getRowKey={r => r.id} emptyTitle="Nessun mittente" />}
        </div>
    );
}
